import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { LanguageService } from 'src/app/components/admin/points-interest/services/language.service';
import { ChangePasswordDialogComponent } from 'src/app/components/shared/components/modal-change-password/modal-change-password.component';
import { environment } from 'src/environments/environment';
import { NotificationService } from '../../services/notification.service';
import { PartnerRedirectDialogService } from '../../services/partner-redirect-dialog.service';
import { AgentService } from './../../../components/admin/partners/services/partner.service';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  httpOptions = {
    headers: new HttpHeaders({
      Platform: 'BACKOFFICE',
      InstitutionId: '1'
    })
  };

  adminOnerEmails = [
    "giovanna@onertravel.com",
    "mickael@onertravel.com",
    "mauricio@onertravel.com",
    "tati@onertravel.com",
    "ricardo@onertravel.com",
    "admin@p2d.travel",
    "talitha@onertravel.com",
    "maria@onertravel.com",
    "jnascimento@befly.com.br",
    "pedro@onertravel.com",
    "alessandra.p.leon@onertravel.com",
    "lucas.teixeira@onertravel.com",
    // 'admin@p2d.travel',
  ];

  readyOpened = false;

  constructor(
    private router: Router,
    private http: HttpClient,
    private tokenService: TokenService,
    private languageService: LanguageService,
    private agentService: AgentService,
    private dialog: MatDialog,
    private loaderService: NgxSpinnerService,
    private notificationService: NotificationService,
    private partnerRedirectDialogService: PartnerRedirectDialogService
  ) { }

  public login(auth: any): Observable<any> {
    return this.http.post<any>(
      environment.apiAuthUrl + '/api/authenticate/backoffice',
      auth,
      this.httpOptions
    );
  }

  public resetPassword(reset: any): Observable<any> {
    const language = this.languageService.getCurrentLanguage();
    const languageId = language ? language.id.toString() : '1';
    this.httpOptions.headers = this.httpOptions.headers.set(
      'language',
      languageId
    );
    return this.http.post<any>(
      environment.apiAuthUrl + '/api/authenticate/forgot-password',
      reset,
      this.httpOptions
    );
  }

  public refreshToken(jwt: string): Observable<any> {
    const languageId = '1';
    this.httpOptions.headers = this.httpOptions.headers.set(
      'language',
      languageId
    ).set('Authorization', `Bearer ${jwt}`);
    return this.http.patch<any>(
      environment.apiAuthUrl + '/api/authenticate/refresh-token',
      null,
      this.httpOptions
    );
  }

  public updatePassword(updatePassword: any): Observable<any> {
    if (this.loaderService) {
      this.loaderService.show();
    }
    return this.http.post<any>(
      environment.apiAuthUrl + '/api/authenticate/update-password',
      updatePassword,
      this.httpOptions
    );
  }

  public addImageProfile(id: string, userImage: any): Observable<any> {
    return this.http.patch<any>(
      environment.apiAuthUrl + '/api/users/update-image-profile/' + id,
      userImage,
      this.httpOptions
    );
  }

  public getLoggedPersonId(): string {
    return this.tokenService.getToken(this.tokenService.TOKEN_PERSON_ID);
  }

  public createUserSession(authToken: any, rememberUser: string = 'true', bookingIdToCartMarkup?: string, redirectComponent?: string): void {
    const tokenDecoded: any = this.tokenService.decodeToken(authToken);

    if (tokenDecoded?.role === 'AGENT') {
      this.handleAgentBlockedAccess(authToken, tokenDecoded.PersonId);
      return;
    }

    this.tokenService.createToken(this.tokenService.EMAIL, tokenDecoded.email);
    this.tokenService.createToken(
      this.tokenService.LOGIN_USER_TOKEN,
      authToken
    );
    this.tokenService.createToken(
      this.tokenService.LOGIN_IS_FIRST_ACCESS,
      tokenDecoded.IsFisrtAccess
    );
    this.tokenService.createToken(
      this.tokenService.CHANGE_PASSWORD,
      tokenDecoded.ChangePassword
    );
    this.tokenService.createToken(
      this.tokenService.TOKEN_FULL_NAME,
      tokenDecoded.FullName
    );
    this.tokenService.createToken(
      this.tokenService.TOKEN_PERSON_ID,
      tokenDecoded.PersonId
    );
    this.tokenService.createToken(
      this.tokenService.TOKEN_USER_ID,
      tokenDecoded.UserId
    );
    this.tokenService.createToken(
      this.tokenService.TOKEN_IMAGE_PROFILE,
      tokenDecoded.ImageProfile
    );
    this.tokenService.createToken(
      this.tokenService.TOKEN_ROLE,
      tokenDecoded.role
    );
    this.tokenService.createToken(
      this.tokenService.TOKEN_INTITUTION_ID,
      tokenDecoded.InstitutionId
    );
    this.tokenService.createToken(
      this.tokenService.TOKEN_INTITUTION_LOGO,
      tokenDecoded.InstitutionLogo
    );
    this.tokenService.createToken(
      this.tokenService.TOKEN_INTITUTION_LOGO,
      tokenDecoded.InstitutionLogo
    );
    this.tokenService.createToken(
      this.tokenService.REMEMBER_USER,
      rememberUser
    );

    if (!this.tokenService.verifyTokenActive(this.tokenService.AGENT)) {
      this.agentService.getAgentByPerson(tokenDecoded.PersonId).subscribe(
        (agent: any) => {
          this.tokenService.createToken(
            this.tokenService.AGENT,
            JSON.stringify(agent.data)
          );
        },
        (err) => console.log(err)
      );
    }

    if (redirectComponent) {
      switch (redirectComponent) {
        case 'profile':
          this.router.navigate([`/admin/profile/company`]);
          break;

        case 'contract':
          this.router.navigate([`/admin/profile/contract`]);
          break;

        case 'personalization':
          this.router.navigate([`/admin/site/data`]);
          break;

        case 'commission':
          this.router.navigate([`/admin/comissions/bonus`]);
          break;

        case 'cart':
          this.router.navigate([`/admin/booking-agent`]);
          break;

        case 'sale':
          this.router.navigate([`/admin/sales-agent`]);
          break;

        case 'cupon':
          this.router.navigate([`/admin/coupon`]);
          break;

        case 'booking-agent':
          this.router.navigate([`/admin/booking-agent/${bookingIdToCartMarkup}/cart-markup`]);
          break;

        default:
          this.router.navigate(['/admin']);
          break;
      }
    } else {
      if (bookingIdToCartMarkup) {
        this.router.navigate([`/admin/booking-agent/${bookingIdToCartMarkup}/cart-markup`]);
      } else {
        this.router.navigate(['/admin']);
      }
    }
  }

  public logout() {
    this.tokenService.removeToken();
  }

  private handleAgentBlockedAccess(authToken: any, personId: string): void {
    this.tokenService.createToken(this.tokenService.LOGIN_USER_TOKEN, authToken);

    if (!personId) {
      this.tokenService.removeToken();
      this.partnerRedirectDialogService.open(null);
      return;
    }

    const finish = (agencySite: string | null) => {
      this.tokenService.removeToken();
      this.partnerRedirectDialogService.open(agencySite);
    };

    this.agentService.getAgentByPerson(personId).pipe(
      switchMap((agentResult: any) => {
        if (!agentResult?.success || !agentResult.data?.id) {
          return of(null);
        }
        return this.agentService.getAgency(agentResult.data.id);
      })
    ).subscribe({
      next: (result: any) => {
        const agencySite = result?.success ? result.data?.agencySite : null;
        finish(agencySite);
      },
      error: () => {
        finish(null);
      }
    });
  }

  public removeOnlyToken(keyToken: string): void {
    localStorage.removeItem(keyToken);
  }

  public check(isAuthenticationComponent = false): boolean {
    var isValid = this.tokenService.verifyTokenExpired(
      this.tokenService.getToken('userToken')
    );

    if (!isValid) {
      var needChangePassword = this.tokenService.getToken(this.tokenService.CHANGE_PASSWORD);
      if (needChangePassword == 'True' && !isAuthenticationComponent) {
        setTimeout(() => {
          if (!this.readyOpened) {
            this.readyOpened = true;
            this.changePassword();
          }
        }, 1000);
      }
    }

    return isValid;
  }

  public sendBackofficeCode(email: any) {
    this.setLanguageToHeaders();
    return this.http.post(
      environment.apiAuthUrl + `/api/authenticate/send-backofficecode`,
      email,
      this.httpOptions
    );
  }

  public authenticationCode(code: any) {
    this.setLanguageToHeaders();
    return this.http.post(
      environment.apiAuthUrl + `/api/authenticate/code-backoffice`,
      code,
      this.httpOptions
    );
  }

  private setLanguageToHeaders(): any {
    const language = this.languageService.getCurrentLanguage();
    const languageId = language ? language.id.toString() : '1';
    this.httpOptions.headers = this.httpOptions.headers.set(
      'language',
      languageId
    );
  }

  public masterAccess(): boolean {
    const thereAccess = this.adminOnerEmails.includes(
      this.tokenService.getToken(this.tokenService.EMAIL)
    );

    return thereAccess;
  }

  public changePassword() {
    const dialogRef = this.dialog.open(ChangePasswordDialogComponent, {
      width: '400px',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.updatePassword({
          currentPassword: result.currentPassword,
          newPassword: result.newPassword,
          confirmPassword: result.confirmPassword
        }).subscribe({
          next: (result: any) => {
            this.createUserSession(result.data.token);
            this.readyOpened = false;
          }
          ,
          error: (error) => {
            console.error('Error updating password:', error);
            this.notificationService.messageError('Não foi possível alterar a senha, pois o login/senha está incorreto.');
            this.changePassword();
          }
        });
      }
    });
  }
}
